import { put, select, takeLatest } from 'redux-saga/effects';
import { getInventory } from '../Services/InventoryService';
import { tableAction, tableActions, tableInitialState } from '../../App/Ducks/Table.duck';

export const actionTypes = {
  RequestData: '[Inventory] RequestInventory',
  FulfilledTable: '[Inventory] FulfilledInventory',
  SearchTable: '[Inventory] Search Inventory',
  ChangePage: '[Inventory] change page',
  SetPageSize: '[Inventory] set page size',
  SortTable: '[Inventory] Sort Inventory',
  ApplyFilter: '[Inventory] Apply filter',
  RemoveFilter: '[Inventory] Remove filter',
  ResetFilters: '[Inventory] Reset filter',
};

const initialState = {
  ...tableInitialState,
  sortBy: { name: 'asc' },
};

export const reducer = (state = initialState, action) => {
  const newState = tableAction(actionTypes, state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export const actions = {
  ...tableActions(actionTypes),
};

export function* saga() {
  function* reloadData() {
    yield put(actions.requestData());
  }

  yield takeLatest(actionTypes.SearchTable, reloadData);
  yield takeLatest(actionTypes.ChangePage, reloadData);
  yield takeLatest(actionTypes.SetPageSize, reloadData);
  yield takeLatest(actionTypes.SortTable, reloadData);
  yield takeLatest(actionTypes.ApplyFilter, reloadData);
  yield takeLatest(actionTypes.RemoveFilter, reloadData);
  yield takeLatest(actionTypes.ResetFilters, reloadData);

  yield takeLatest(actionTypes.RequestData, function* requestInventorySaga() {
    const currentTenantId = yield select(state => state.AppReducer.tenant.tenantId);
    const currentState = yield select(state => state.InventoryReducer);

    const response = yield getInventory(
      currentTenantId,
      currentState.page,
      currentState.pageSize,
      currentState.sortBy,
      { ...currentState.filters, name: currentState.filters.type || null },
      currentState.searchQuery,
    );

    yield put(actions.fulfilled(response.items, response.total));
  });
}
